<template>
  <div class="lesson-data-container">
    <!-- Tab 切换 -->
    <div class="tab-container">
      <base-tabs :tabs="tabs" :active-index="activeTabIndex" @updateSubject="handleTabChange" />
    </div>

    <!-- 内容展示区域 -->
    <div class="content-container">
      <!-- 按讲次查看 -->
      <lesson-view
        v-if="activeTabIndex === 1"
        :institution-id="institutionId"
        :teacher-id="teacherId"
        :roles="roles"
        :initial-filters="sharedFilters"
        @filter-change="updateFilters"
      />
      <!-- 按学生查看 -->
      <student-view
        v-if="activeTabIndex === 2"
        :institution-id="institutionId"
        :teacher-id="teacherId"
        :roles="roles"
        :initial-filters="sharedFilters"
        @filter-change="updateFilters"
      />
    </div>
  </div>
</template>

<script>
import BaseTabs from '@/views/index/components/common/BaseTabs.vue';
import beike from '@/service/beike';
import { message } from 'ant-design-vue';
import LessonView from './components/lessonView.vue';
import StudentView from './components/studentView.vue';

// 本地存储键名
const STORAGE_KEY_PREFIX = 'lesson_data_filters_';
const TAB_KEY_PREFIX = 'lesson_data_tab_';

export default {
  name: 'LessonData',
  components: {
    BaseTabs,
    LessonView,
    StudentView,
  },
  data() {
    return {
      activeTabIndex: 1,
      tabs: [
        { id: 1, name: '按讲次查看' },
        { id: 2, name: '按学生查看' },
      ],
      institutionId: null,
      teacherId: null,
      roles: [],
      // 共享的筛选条件
      sharedFilters: {
        term: '',
        grade: '',
        classTime: '',
        termLabel: '',
      },
    };
  },
  async created() {
    await this.fetchUserInfo();
    // 从本地存储恢复状态
    this.restoreState();
  },
  methods: {
    getStorageKey() {
      return `${STORAGE_KEY_PREFIX}${this.teacherId || 'guest'}`;
    },
    getTabKey() {
      return `${TAB_KEY_PREFIX}${this.teacherId || 'guest'}`;
    },
    handleTabChange(id) {
      this.activeTabIndex = id;
      // 保存 Tab 状态到本地存储
      sessionStorage.setItem(this.getTabKey(), id.toString());
    },
    async fetchUserInfo() {
      try {
        const response = await beike.getMenu();
        this.institutionId = response.institutionId;
        this.teacherId = response.teacherId || response.userId;
        this.roles = response.roles || [];
      } catch (error) {
        this.$message.error('获取用户信息失败');
      }
    },
    // 更新筛选条件
    updateFilters(filters) {
      this.sharedFilters = { ...filters };
      // 保存到本地存储
      this.saveState();
    },
    // 保存状态到本地存储
    saveState() {
      try {
        sessionStorage.setItem(this.getStorageKey(), JSON.stringify(this.sharedFilters));
      } catch (e) {
        message.error('保存筛选条件到本地存储失败', e);
      }
    },
    // 从本地存储恢复状态
    restoreState() {
      console.log('restoreState', this.getTabKey());
      try {
        // 恢复 Tab
        const savedTab = sessionStorage.getItem(this.getTabKey());
        if (savedTab) {
          this.activeTabIndex = parseInt(savedTab, 10) || 1;
        }

        // 恢复筛选条件
        const savedFilters = sessionStorage.getItem(this.getStorageKey());
        if (savedFilters) {
          const parsedFilters = JSON.parse(savedFilters);
          if (parsedFilters && typeof parsedFilters === 'object') {
            this.sharedFilters = parsedFilters;
          }
        }
      } catch (e) {
        message.error('从本地存储恢复状态失败', e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 样式保持不变
.lesson-data-container {
  padding: 20px;

  h1 {
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: bold;
    color: #303858;
  }

  .tab-container {
    margin-bottom: 20px;
  }

  .content-container {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
  }
}
</style>
